import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';
import {
  CompaniesResponseType,
  OneCompanyResponseData,
} from '../../pages/admin-dashboard/admin-companies/admin-companies.model';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  private httpClient = inject(HttpClient);
  private API = environment.productsApiUrl;
  private authService = inject(AuthService);

  protected getHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  getMFGCompanies(apiParams?: any) {
    let params = new HttpParams();

    if (apiParams?.orderBy) {
      params = params.set('orderBy', apiParams.orderBy);
    }

    if (apiParams?.orderDir) {
      params = params.set('orderDir', apiParams.orderDir);
    }
    if (apiParams?.page) {
      params = params.set('page', apiParams.page);
    }

    if (apiParams?.size) {
      params = params.set('size', apiParams.size);
    }
    return this.httpClient.get<CompaniesResponseType>(`${this.API}/companies/mfg`, {
      headers: this.getHeaders(),
      params,
    });
  }

  getOneMFGCompany(companyId: number) {
    return this.httpClient.get<OneCompanyResponseData>(`${this.API}/companies/mfg/${companyId}`, {
      headers: this.getHeaders(),
    });
  }

  createMFGCompany(companyRequest: any) {
    return this.httpClient.post(`${this.API}/companies/mfg`, companyRequest, {
      headers: this.getHeaders(),
    });
  }

  activateCompany(companyId: number) {
    return this.httpClient.patch(
      `${this.API}/companies/mfg/${companyId}/activate`,
      {},
      {
        headers: this.getHeaders(),
      },
    );
  }
  deactivateCompany(companyId: number) {
    return this.httpClient.patch(
      `${this.API}/companies/mfg/${companyId}/deactivate`,
      {},
      {
        headers: this.getHeaders(),
      },
    );
  }
  deleteCompany(companyId: number) {
    return this.httpClient.delete(`${this.API}/companies/mfg/${companyId}`, {
      headers: this.getHeaders(),
    });
  }

  updateCompany(companyId: number, companyBody: any) {
    return this.httpClient.put(`${this.API}/companies/mfg/${companyId}`, companyBody, {
      headers: this.getHeaders(),
    });
  }
}
